import React from 'react';

interface IconProps {
    width?: number;
    height?: number;
    stroke?: string;
    fill?: string;
}

export const MailIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_3_305)">
                <path
                    d="M14.0057 14.7041C13.4086 15.1021 12.7151 15.3126 12 15.3126C11.285 15.3126 10.5914 15.1021 9.99431 14.7041L0.159797 8.14752C0.105234 8.11115 0.0520781 8.07323 0 8.03423V18.7778C0 20.0096 0.999609 20.9872 2.20936 20.9872H21.7906C23.0224 20.9872 24 19.9876 24 18.7778V8.03418C23.9478 8.07327 23.8945 8.11129 23.8398 8.14771L14.0057 14.7041Z"
                    fill={strokeColor}
                />
                <path
                    d="M0.939844 6.97795L10.7744 13.5345C11.1466 13.7827 11.5733 13.9068 12 13.9068C12.4267 13.9068 12.8534 13.7827 13.2256 13.5345L23.0602 6.97795C23.6487 6.58584 24 5.92959 24 5.2213C24 4.00345 23.0092 3.0127 21.7914 3.0127H2.20861C0.990797 3.01274 0 4.00349 0 5.22248C0 5.92959 0.351375 6.58584 0.939844 6.97795Z"
                    fill={strokeColor}
                />
            </g>
            <defs>
                <clipPath id="clip0_3_305">
                    <rect width={iconWidth} height={iconHeight} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const TasksIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M16.337 2H7.95697C4.31697 2 2.14697 4.17 2.14697 7.81V16.19C2.14697 19.83 4.31697 22 7.95697 22H16.337C19.977 22 22.147 19.83 22.147 16.19V7.81C22.147 4.17 19.977 2 16.337 2ZM10.117 14.9L7.86697 17.15C7.71697 17.3 7.52697 17.37 7.33697 17.37C7.14697 17.37 6.94697 17.3 6.80697 17.15L6.05697 16.4C5.75697 16.11 5.75697 15.63 6.05697 15.34C6.34697 15.05 6.81697 15.05 7.11697 15.34L7.33697 15.56L9.05697 13.84C9.34697 13.55 9.81697 13.55 10.117 13.84C10.407 14.13 10.407 14.61 10.117 14.9ZM10.117 7.9L7.86697 10.15C7.71697 10.3 7.52697 10.37 7.33697 10.37C7.14697 10.37 6.94697 10.3 6.80697 10.15L6.05697 9.4C5.75697 9.11 5.75697 8.63 6.05697 8.34C6.34697 8.05 6.81697 8.05 7.11697 8.34L7.33697 8.56L9.05697 6.84C9.34697 6.55 9.81697 6.55 10.117 6.84C10.407 7.13 10.407 7.61 10.117 7.9ZM17.707 16.62H12.457C12.047 16.62 11.707 16.28 11.707 15.87C11.707 15.46 12.047 15.12 12.457 15.12H17.707C18.127 15.12 18.457 15.46 18.457 15.87C18.457 16.28 18.127 16.62 17.707 16.62ZM17.707 9.62H12.457C12.047 9.62 11.707 9.28 11.707 8.87C11.707 8.46 12.047 8.12 12.457 8.12H17.707C18.127 8.12 18.457 8.46 18.457 8.87C18.457 9.28 18.127 9.62 17.707 9.62Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const AnalyticsIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M7.60152 12.9091V21.0909C7.60152 21.332 7.50574 21.5632 7.33525 21.7337C7.16476 21.9042 6.93353 22 6.69243 22H3.05606C2.81496 22 2.58373 21.9042 2.41324 21.7337C2.24275 21.5632 2.14697 21.332 2.14697 21.0909V12.9091C2.14697 12.668 2.24275 12.4368 2.41324 12.2663C2.58373 12.0958 2.81496 12 3.05606 12H6.69243C6.93353 12 7.16476 12.0958 7.33525 12.2663C7.50574 12.4368 7.60152 12.668 7.60152 12.9091ZM13.9652 2H10.3288C10.0877 2 9.85645 2.09578 9.68597 2.26627C9.51548 2.43675 9.4197 2.66799 9.4197 2.90909V21.0909C9.4197 21.332 9.51548 21.5632 9.68597 21.7337C9.85645 21.9042 10.0877 22 10.3288 22H13.9652C14.2063 22 14.4375 21.9042 14.608 21.7337C14.7785 21.5632 14.8742 21.332 14.8742 21.0909V2.90909C14.8742 2.66799 14.7785 2.43675 14.608 2.26627C14.4375 2.09578 14.2063 2 13.9652 2ZM21.2379 6.54545H17.6015C17.3604 6.54545 17.1292 6.64123 16.9587 6.81172C16.7882 6.98221 16.6924 7.21344 16.6924 7.45455V21.0909C16.6924 21.332 16.7882 21.5632 16.9587 21.7337C17.1292 21.9042 17.3604 22 17.6015 22H21.2379C21.479 22 21.7102 21.9042 21.8807 21.7337C22.0512 21.5632 22.147 21.332 22.147 21.0909V7.45455C22.147 7.21344 22.0512 6.98221 21.8807 6.81172C21.7102 6.64123 21.479 6.54545 21.2379 6.54545Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const DashboardIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M4.00001 2H8.99998C10.104 2 11 2.89798 11 4.00001V8.99998C11 10.102 10.104 11 9.00003 11H4.00001C2.897 11 2 10.102 2 9.00003V4.00001C2 2.89798 2.897 2 4.00001 2Z"
                fill={strokeColor}
            />
            <path
                d="M15 2H20C21.104 2 22 2.89798 22 4.00001V9.00003C22 10.1021 21.104 11 20 11H15C13.896 11 13 10.102 13 9.00003V4.00001C13 2.89798 13.896 2 15 2Z"
                fill={strokeColor}
            />
            <path
                d="M8.99998 13H4.00001C2.897 13 2 13.8979 2 14.9999V19.9999C2 21.103 2.897 22 4.00001 22H9.00003C10.104 22 11 21.103 11 19.9999V14.9999C11 13.8979 10.104 13 8.99998 13Z"
                fill={strokeColor}
            />
            <path
                d="M15 13H20C21.104 13 22 13.8979 22 14.9999V19.9999C22 21.103 21.104 22 20 22H15C13.896 22 13 21.103 13 19.9999V15C13 13.8979 13.896 13 15 13Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const QuestionIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9964 9.34893 20.9417 6.80748 19.0671 4.93289C17.1925 3.05831 14.6511 2.00359 12 2V2ZM11.7492 17.5661C11.548 17.5661 11.3514 17.5065 11.1842 17.3947C11.0169 17.283 10.8866 17.1241 10.8096 16.9383C10.7326 16.7525 10.7125 16.548 10.7517 16.3508C10.791 16.1535 10.8878 15.9723 11.0301 15.8301C11.1723 15.6878 11.3535 15.591 11.5508 15.5517C11.748 15.5125 11.9525 15.5326 12.1383 15.6096C12.3241 15.6866 12.483 15.8169 12.5947 15.9842C12.7065 16.1514 12.7661 16.348 12.7661 16.5491C12.7661 16.8189 12.659 17.0775 12.4682 17.2682C12.2775 17.459 12.0189 17.5661 11.7492 17.5661ZM13.4915 12.6881C13.2313 12.7688 13.0038 12.9309 12.8427 13.1506C12.6816 13.3703 12.5953 13.636 12.5966 13.9085C12.5966 14.1332 12.5073 14.3488 12.3484 14.5077C12.1895 14.6666 11.9739 14.7559 11.7492 14.7559C11.5244 14.7559 11.3088 14.6666 11.1499 14.5077C10.991 14.3488 10.9017 14.1332 10.9017 13.9085C10.899 13.2736 11.1006 12.6548 11.4766 12.1432C11.8526 11.6317 12.3831 11.2547 12.9898 11.0678C13.2504 10.9873 13.4783 10.8253 13.64 10.6056C13.8017 10.386 13.8887 10.1202 13.8881 9.84746C13.8675 9.36098 13.6597 8.90127 13.3082 8.56434C12.9567 8.22741 12.4886 8.03931 12.0017 8.03931C11.5148 8.03931 11.0467 8.22741 10.6952 8.56434C10.3437 8.90127 10.1359 9.36098 10.1153 9.84746C10.1153 10.0722 10.026 10.2878 9.86704 10.4467C9.70811 10.6056 9.49256 10.6949 9.2678 10.6949C9.04304 10.6949 8.82749 10.6056 8.66856 10.4467C8.50963 10.2878 8.42034 10.0722 8.42034 9.84746C8.44898 8.91669 8.83885 8.03364 9.50736 7.38539C10.1759 6.73713 11.0705 6.3746 12.0017 6.3746C12.9329 6.3746 13.8275 6.73713 14.496 7.38539C15.1645 8.03364 15.5544 8.91669 15.5831 9.84746C15.585 10.4826 15.3827 11.1015 15.0061 11.613C14.6296 12.1245 14.0986 12.5014 13.4915 12.6881Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const SettingsIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M17.8995 11.8267L16.3676 10.6288C16.387 10.4441 16.4037 10.2281 16.4037 9.99964C16.4037 9.77116 16.3877 9.55521 16.3676 9.37048L17.9009 8.17188C18.1857 7.94688 18.2634 7.54756 18.0822 7.21494L16.4891 4.45866C16.319 4.14756 15.9461 3.98783 15.5676 4.12741L13.76 4.85309C13.4134 4.60309 13.0502 4.39199 12.6745 4.22324L12.3995 2.30589C12.3544 1.94199 12.0377 1.66699 11.6634 1.66699H8.469C8.09469 1.66699 7.77873 1.94199 7.73427 2.30033L7.45858 4.22464C7.09469 4.38854 6.73707 4.59688 6.37525 4.85449L4.56275 4.12673C4.22314 3.99548 3.81689 4.14268 3.64814 4.45241L2.05302 7.21214C1.86484 7.53021 1.9426 7.94339 2.23359 8.17396L3.76552 9.37188C3.7412 9.60589 3.72942 9.80938 3.72942 10.0004C3.72942 10.1913 3.74123 10.3948 3.76552 10.6295L2.23219 11.8281C1.94745 12.0538 1.87037 12.4531 2.05162 12.7851L3.64469 15.5413C3.81484 15.8517 4.18427 16.0128 4.5662 15.8726L6.37385 15.1469C6.71969 15.3962 7.08287 15.6073 7.45858 15.7767L7.73358 17.6934C7.7787 18.0587 8.09469 18.3337 8.46969 18.3337H11.6641C12.0384 18.3337 12.3551 18.0587 12.3995 17.7003L12.6752 15.7767C13.0391 15.6121 13.3961 15.4045 13.7586 15.1462L15.5711 15.8739C15.6586 15.9079 15.7495 15.9253 15.8433 15.9253C16.1127 15.9253 16.3606 15.7781 16.4856 15.5489L18.0856 12.7781C18.2634 12.4531 18.1856 12.0538 17.8995 11.8267ZM10.0662 12.7781C8.53427 12.7781 7.28844 11.5323 7.28844 10.0003C7.28844 8.46839 8.53427 7.22256 10.0662 7.22256C11.5981 7.22256 12.844 8.46839 12.844 10.0003C12.844 11.5323 11.5981 12.7781 10.0662 12.7781Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const LogOutIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M12.3673 10.6947C11.9833 10.6947 11.6729 11.0059 11.6729 11.3891V14.167C11.6729 14.5496 11.3618 14.8614 10.9784 14.8614H8.89509V4.44473C8.89509 3.85167 8.5173 3.32181 7.9493 3.12459L7.74368 3.0558H10.9784C11.3618 3.0558 11.6729 3.36758 11.6729 3.75033V5.83366C11.6729 6.21691 11.9833 6.52806 12.3673 6.52806C12.7514 6.52806 13.0618 6.21691 13.0618 5.83366V3.75033C13.0618 2.60172 12.127 1.66699 10.9784 1.66699H3.51318C3.48673 1.66699 3.46461 1.67882 3.43892 1.68225C3.40548 1.67945 3.37357 1.66699 3.33961 1.66699C2.57362 1.66699 1.95068 2.28981 1.95068 3.0558V15.5558C1.95068 16.1489 2.32847 16.6787 2.89647 16.8759L7.07573 18.2691C7.21738 18.3128 7.35827 18.3337 7.50628 18.3337C8.27227 18.3337 8.89509 17.7107 8.89509 16.9447V16.2503H10.9784C12.127 16.2503 13.0618 15.3156 13.0618 14.167V11.3891C13.0618 11.0059 12.7514 10.6947 12.3673 10.6947Z"
                fill={strokeColor}
            />
            <path
                d="M18.4135 8.12007L15.6356 5.34233C15.4372 5.14371 15.1385 5.08395 14.8788 5.19153C14.6198 5.29923 14.4503 5.55265 14.4503 5.83328V7.91662H11.6726C11.2892 7.91662 10.978 8.22764 10.978 8.61102C10.978 8.9944 11.2892 9.30542 11.6726 9.30542H14.4503V11.3888C14.4503 11.6694 14.6198 11.9228 14.8788 12.0305C15.1385 12.1381 15.4372 12.0783 15.6356 11.8798L18.4135 9.10197C18.685 8.83049 18.685 8.39155 18.4135 8.12007Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const UnViewIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.10342 3.50657L3.11 2.5L17.1034 16.4973L16.0968 17.4999L13.46 14.8591C12.3902 15.2894 11.2218 15.5262 9.99814 15.5262C6.05078 15.5262 2.67976 13.071 1.31396 9.60523C1.92975 8.03815 2.96001 6.6842 4.26263 5.66578L2.10342 3.50657ZM7.68894 9.08814L6.46921 7.8684C6.20869 8.39734 6.05078 8.98156 6.05078 9.60523C6.05078 11.7842 7.81921 13.5526 9.99814 13.5526C10.6218 13.5526 11.206 13.3947 11.731 13.1342L10.5113 11.9144C10.3455 11.9499 10.1758 11.9736 9.99814 11.9736C8.69156 11.9736 7.62973 10.9118 7.62973 9.60523C7.62973 9.42759 7.65342 9.25788 7.68894 9.08814Z"
                fill={strokeColor}
            />
            <path
                d="M9.99828 5.65774C12.1772 5.65774 13.9456 7.42617 13.9456 9.6051C13.9456 10.1143 13.843 10.5998 13.6654 11.0459L15.9746 13.3551C17.1667 12.3603 18.1062 11.0735 18.6864 9.6051C17.3167 6.13934 13.9496 3.68408 9.99832 3.68408C8.89305 3.68408 7.83518 3.88144 6.8523 4.2367L8.55755 5.93799C9.00355 5.76432 9.48907 5.65774 9.99828 5.65774Z"
                fill={strokeColor}
            />
            <path
                d="M9.86784 7.24898L12.3547 9.73581L12.3665 9.60555C12.3665 8.29897 11.3047 7.23714 9.9981 7.23714L9.86784 7.24898Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ArrowRoundedIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 16;
    const iconHeight = height ?? 16;
    const strokeColor = stroke ?? '#fff';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 16 16"
            fill="none"
        >
            <circle cx="8" cy="8" r="8" fill="#437EC3" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5303 6.46967C11.8232 6.76256 11.8232 7.23744 11.5303 7.53033L8.53033 10.5303C8.23744 10.8232 7.76256 10.8232 7.46967 10.5303L4.46967 7.53033C4.17678 7.23744 4.17678 6.76256 4.46967 6.46967C4.76256 6.17678 5.23744 6.17678 5.53033 6.46967L8 8.93934L10.4697 6.46967C10.7626 6.17678 11.2374 6.17678 11.5303 6.46967Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ArrowDownIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 16;
    const iconHeight = height ?? 16;
    const strokeColor = stroke ?? '#437EC3';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.021 5.6259C13.4376 6.01643 13.4376 6.64959 13.021 7.04012L8.75433 11.0401C8.33777 11.4306 7.66239 11.4306 7.24583 11.0401L2.97917 7.04011C2.56261 6.64959 2.56261 6.01643 2.97917 5.6259C3.39573 5.23538 4.0711 5.23538 4.48766 5.6259L8.00008 8.9188L11.5125 5.6259C11.9291 5.23538 12.6044 5.23538 13.021 5.6259Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const RefreshIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M13.3462 4.06819C12.3257 3.4882 11.1716 3.1841 9.99778 3.18583C8.19055 3.18784 6.45791 3.90665 5.18 5.18455C3.9021 6.46246 3.18329 8.1951 3.18128 10.0023C3.18128 10.2032 3.10149 10.3958 2.95945 10.5379C2.81741 10.6799 2.62477 10.7597 2.42389 10.7597C2.22302 10.7597 2.03038 10.6799 1.88834 10.5379C1.7463 10.3958 1.6665 10.2032 1.6665 10.0023C1.66578 8.51079 2.06548 7.0464 2.82389 5.76207C3.58229 4.47773 4.67158 3.42055 5.97802 2.70089C7.28446 1.98124 8.76015 1.62551 10.251 1.67084C11.7419 1.71618 13.1932 2.16091 14.4535 2.95862L15.5214 1.89297C15.6273 1.78708 15.7623 1.71497 15.9092 1.68576C16.0561 1.65655 16.2083 1.67155 16.3467 1.72886C16.4851 1.78617 16.6034 1.88322 16.6866 2.00774C16.7698 2.13227 16.8142 2.27867 16.8143 2.42844V5.458C16.8143 5.65887 16.7345 5.85151 16.5924 5.99355C16.4504 6.13559 16.2578 6.21539 16.0569 6.21539H13.0273C12.8776 6.21535 12.7312 6.17092 12.6066 6.08769C12.4821 6.00447 12.3851 5.88619 12.3278 5.74782C12.2704 5.60944 12.2554 5.45718 12.2847 5.31028C12.3139 5.16339 12.386 5.02845 12.4919 4.92252L13.3462 4.06819Z"
                fill={strokeColor}
            />
            <path
                d="M17.0361 9.46678C17.1781 9.32474 17.3708 9.24495 17.5717 9.24495C17.7725 9.24495 17.9652 9.32474 18.1072 9.46678C18.2493 9.60882 18.3291 9.80147 18.3291 10.0023C18.3265 12.2111 17.4479 14.3287 15.886 15.8906C14.3242 17.4524 12.2066 18.331 9.99778 18.3336C8.42028 18.3389 6.87429 17.8921 5.54282 17.0461L4.47414 18.1117C4.33214 18.2537 4.13953 18.3336 3.93867 18.3336C3.83911 18.3339 3.74049 18.3144 3.64859 18.2761C3.51023 18.2187 3.39198 18.1216 3.3088 17.997C3.22562 17.8724 3.18124 17.726 3.18128 17.5762V14.5467C3.18128 14.3458 3.26108 14.1532 3.40312 14.0111C3.54515 13.8691 3.7378 13.7893 3.93867 13.7893H6.96823C7.118 13.7893 7.2644 13.8338 7.38892 13.917C7.51345 14.0002 7.6105 14.1185 7.66781 14.2569C7.72512 14.3952 7.74012 14.5475 7.71091 14.6944C7.6817 14.8413 7.60959 14.9762 7.5037 15.0821L6.65012 15.9357C7.67009 16.5165 8.82404 16.8209 9.99778 16.8188C11.805 16.8168 13.5377 16.098 14.8156 14.8201C16.0935 13.5422 16.8123 11.8096 16.8143 10.0023C16.8143 9.80147 16.8941 9.60882 17.0361 9.46678Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CloudServerIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 28;
    const iconHeight = height ?? 28;
    const strokeColor = stroke ?? '#ffffff';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                d="M14.0002 3.5C16.7146 3.5 19.2142 4.98653 20.4859 7.32083C23.4239 7.68736 25.6668 10.1724 25.6668 13.1542C25.6668 16.1787 23.3559 18.6764 20.3916 19.0147C20.6511 18.6025 20.8067 18.1193 20.8067 17.5982C20.8067 16.1233 19.6079 14.9246 18.1331 14.9246H14.0546C13.795 14.2596 13.2817 13.7122 12.5963 13.4274C11.592 13.0112 10.4477 13.2368 9.67961 14.0058C9.41991 14.2655 9.18235 14.4973 8.9661 14.7084C7.73484 15.9098 7.19461 16.437 7.19461 17.5972C7.19461 18.1232 7.34822 18.6249 7.62919 19.0556C4.25072 19.0556 2.3335 16.6017 2.3335 14.0972C2.3335 11.5412 4.29739 9.43055 6.80863 9.16708C7.56405 5.89653 10.5536 3.5 14.0002 3.5Z"
                fill={strokeColor}
            />
            <path
                d="M18.1321 16.8684H12.2988V15.8962C12.2988 15.2497 11.5132 14.922 11.0543 15.3809L9.35293 17.0823C9.06807 17.3672 9.06807 17.829 9.35293 18.1138L11.0543 19.8152C11.5103 20.2712 12.2988 19.9523 12.2988 19.2999V18.3277H18.1321C18.5346 18.3277 18.8613 18.0011 18.8613 17.5986C18.8613 17.1961 18.5346 16.8684 18.1321 16.8684Z"
                fill={strokeColor}
            />
            <path
                d="M18.6474 21.9427L16.946 20.2413C16.4842 19.7805 15.7016 20.113 15.7016 20.7566V21.7288H9.86822C9.46572 21.7288 9.13905 22.0555 9.13905 22.458C9.13905 22.8605 9.46572 23.1872 9.86822 23.1872H15.7016V24.1594C15.7016 24.8098 16.49 25.1306 16.946 24.6747L18.6474 22.9733C18.9322 22.6884 18.9322 22.2276 18.6474 21.9427Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CalendarIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18 5H19C19.7957 5 20.5587 5.31607 21.1213 5.87868C21.6839 6.44129 22 7.20435 22 8V9H2V8C2 7.20435 2.31607 6.44129 2.87868 5.87868C3.44129 5.31607 4.20435 5 5 5H6V3C6 2.73478 6.10536 2.48043 6.29289 2.29289C6.48043 2.10536 6.73478 2 7 2C7.26522 2 7.51957 2.10536 7.70711 2.29289C7.89464 2.48043 8 2.73478 8 3V5H16V3C16 2.73478 16.1054 2.48043 16.2929 2.29289C16.4804 2.10536 16.7348 2 17 2C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V5Z"
                fill={strokeColor}
            />
            <path
                d="M2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V11H22V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CalendarCloseIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M19 5H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2C16.7348 2 16.4804 2.10536 16.2929 2.29289C16.1054 2.48043 16 2.73478 16 3V5H8V3C8 2.73478 7.89464 2.48043 7.70711 2.29289C7.51957 2.10536 7.26522 2 7 2C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V9H22V8C22 7.20435 21.6839 6.44129 21.1213 5.87868C20.5587 5.31607 19.7957 5 19 5Z"
                fill={strokeColor}
            />
            <path
                d="M2 19C2 19.7957 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7957 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7957 22 19V11H2V19ZM15.1822 19.6569C14.7917 20.0474 14.1586 20.0474 13.768 19.6569L12.0005 17.8894L10.2325 19.6574C9.84197 20.0479 9.20881 20.0479 8.81828 19.6574C8.42776 19.2669 8.42776 18.6337 8.81828 18.2432L10.5863 16.4751L8.81828 14.7071C8.42776 14.3166 8.42776 13.6834 8.81828 13.2929C9.20881 12.9024 9.84197 12.9024 10.2325 13.2929L12.0005 15.0609L13.768 13.2934C14.1586 12.9029 14.7917 12.9029 15.1822 13.2934C15.5728 13.6839 15.5728 14.3171 15.1822 14.7076L13.4147 16.4751L15.1822 18.2426C15.5728 18.6332 15.5728 19.2663 15.1822 19.6569Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ArrowIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="4" y1="12" x2="20" y2="12" />
            <polyline points="14 6 20 12 14 18" />
        </svg>
    );
};

export const CheckIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M3.83301 10L8.41634 14.5833L17.9997 5"
                stroke={strokeColor}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CancelIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M10.5002 1.66602C5.90526 1.66602 2.16699 5.40449 2.16699 9.99975C2.16745 14.5946 5.90572 18.3327 10.5002 18.3327C15.0951 18.3327 18.8333 14.5945 18.8333 9.99965C18.8333 5.40449 15.0951 1.66602 10.5002 1.66602ZM10.5002 3.18426C12.1062 3.18426 13.5839 3.74307 14.75 4.67603L5.17686 14.2491C4.2441 13.0831 3.68539 11.6055 3.68524 9.9997C3.68524 6.24165 6.74242 3.18426 10.5002 3.18426ZM10.5002 16.8144C8.89428 16.8144 7.41647 16.2556 6.25031 15.3227L15.8236 5.74963C16.7563 6.9158 17.3151 8.3936 17.3151 9.99965C17.315 13.7574 14.2579 16.8144 10.5002 16.8144Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const SearchIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M21.2519 17.7606L17.9601 14.4688C18.5586 13.2718 18.9576 11.8753 18.9576 10.4788C18.9576 5.79052 15.1671 2 10.4788 2C5.79052 2 2 5.79052 2 10.4788C2 15.1671 5.79052 18.9576 10.4788 18.9576C11.8753 18.9576 13.2718 18.5586 14.4688 17.9601L17.7606 21.2519C18.7581 22.2494 20.2544 22.2494 21.2519 21.2519C22.1496 20.2544 22.1496 18.7581 21.2519 17.7606ZM10.4788 16.9626C6.88778 16.9626 3.99501 14.0698 3.99501 10.4788C3.99501 6.88778 6.88778 3.99501 10.4788 3.99501C14.0698 3.99501 16.9626 6.88778 16.9626 10.4788C16.9626 14.0698 14.0698 16.9626 10.4788 16.9626Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ArrowDropDownIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.2735 9.72647C17.7422 10.1951 17.7422 10.9549 17.2735 11.4235L12.4735 16.2235C12.0049 16.6922 11.2451 16.6922 10.7765 16.2235L5.97647 11.4235C5.50784 10.9549 5.50784 10.1951 5.97647 9.72647C6.4451 9.25784 7.2049 9.25784 7.67353 9.72647L11.625 13.6779L15.5765 9.72647C16.0451 9.25784 16.8049 9.25784 17.2735 9.72647Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CloseIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M17.7525 7.44263C18.0825 7.11261 18.0825 6.57754 17.7525 6.24752C17.4225 5.91749 16.8874 5.91749 16.5574 6.24752L12 10.8049L7.44263 6.24752C7.11261 5.91749 6.57754 5.91749 6.24752 6.24752C5.91749 6.57754 5.91749 7.11261 6.24752 7.44263L10.8049 12L6.24752 16.5574C5.91749 16.8874 5.91749 17.4225 6.24752 17.7525C6.57754 18.0825 7.11261 18.0825 7.44263 17.7525L12 13.1951L16.5574 17.7525C16.8874 18.0825 17.4225 18.0825 17.7525 17.7525C18.0825 17.4225 18.0825 16.8874 17.7525 16.5574L13.1951 12L17.7525 7.44263Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const LanguageIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M7.24597 14.3438C7.83252 15.5143 8.82953 16.4359 10.0605 16.9101C9.69592 16.2041 9.42783 15.3115 9.26395 14.3438H7.24597Z"
                fill={strokeColor}
            />
            <path
                d="M7.24597 9.65622H9.26395C9.42783 8.68851 9.69592 7.79587 10.0605 7.08984C8.82953 7.56409 7.83252 8.48572 7.24597 9.65622Z"
                fill={strokeColor}
            />
            <path
                d="M12.0236 6.73413C12.0111 6.73398 11.9996 6.73047 11.9873 6.73047C11.4669 6.74725 10.7869 7.83765 10.4506 9.65588H13.5492C13.2151 7.85001 12.5425 6.76495 12.0236 6.73413Z"
                fill={strokeColor}
            />
            <path
                d="M11.9873 17.2692C11.9996 17.269 12.0111 17.2657 12.0236 17.2655C12.5424 17.2347 13.2151 16.1498 13.5492 14.3438H10.4506C10.7869 16.162 11.4669 17.2524 11.9873 17.2692Z"
                fill={strokeColor}
            />
            <path
                d="M9.07031 12C9.07031 11.6101 9.08633 11.2172 9.11807 10.8281H6.81323C6.72672 11.2064 6.67163 11.5959 6.67163 12C6.67163 12.4041 6.72687 12.7936 6.81323 13.1719H9.11807C9.08633 12.7828 9.07031 12.3899 9.07031 12Z"
                fill={strokeColor}
            />
            <path
                d="M13.9623 7.13086C14.3155 7.83002 14.5755 8.7077 14.7361 9.65588H16.6442C16.0781 8.52612 15.1351 7.61853 13.9623 7.13086Z"
                fill={strokeColor}
            />
            <path
                d="M14.9296 12C14.9296 12.3899 14.9136 12.7828 14.8818 13.1719H17.0768C17.1633 12.7936 17.2184 12.4041 17.2184 12C17.2184 11.5959 17.1633 11.2064 17.0768 10.8281H14.8818C14.9136 11.2172 14.9296 11.6101 14.9296 12Z"
                fill={strokeColor}
            />
            <path
                d="M22 12C22 6.50745 17.4926 2 12 2C6.50745 2 2 6.50745 2 12C2 17.4926 6.50745 22 12 22C13.8379 22 15.6238 21.4597 17.1831 20.5081L22 22L20.6255 16.9857C21.4997 15.475 22 13.7572 22 12ZM12.047 18.4401C12.0311 18.4407 12.0162 18.4453 12 18.4453C11.994 18.4453 11.9887 18.4435 11.9828 18.4433C11.9701 18.4435 11.9577 18.4453 11.9451 18.4453C8.39114 18.4453 5.49976 15.5539 5.49976 12C5.49976 8.44608 8.39114 5.55469 11.9451 5.55469C11.9577 5.55469 11.9701 5.55652 11.9828 5.55667C11.9887 5.55652 11.994 5.55469 12 5.55469C12.0162 5.55469 12.0311 5.55927 12.047 5.55988C15.5538 5.61511 18.3904 8.48041 18.3904 12C18.3904 15.5196 15.5538 18.3849 12.047 18.4401Z"
                fill={strokeColor}
            />
            <path
                d="M10.2909 10.8281C10.2599 11.1989 10.2422 11.5894 10.2422 12C10.2422 12.4106 10.2599 12.8011 10.2909 13.1719H13.7091C13.7401 12.8011 13.7578 12.4106 13.7578 12C13.7578 11.5894 13.7401 11.1989 13.7091 10.8281H10.2909Z"
                fill={strokeColor}
            />
            <path
                d="M13.9623 16.8688C15.1351 16.3811 16.0781 15.4735 16.6442 14.3438H14.7361C14.5755 15.2919 14.3155 16.1696 13.9623 16.8688Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const LightThemeIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 5.51816C11.4601 5.51816 11.0226 5.0806 11.0226 4.54119V2.97741C11.0226 2.43756 11.4601 2 12 2C12.5399 2 12.9774 2.43756 12.9774 2.97741V4.54119C12.9774 5.0806 12.5394 5.51816 12 5.51816Z"
                fill={strokeColor}
            />
            <path
                d="M12 6.9907C9.23782 6.9907 6.9907 9.23826 6.9907 12.0004C6.9907 14.7626 9.23782 17.0102 12 17.0102C14.7617 17.0102 17.0093 14.7631 17.0093 12.0004C17.0093 9.23782 14.7617 6.9907 12 6.9907Z"
                fill={strokeColor}
            />
            <path
                d="M11.0226 19.4588C11.0226 18.919 11.4601 18.4814 12 18.4814C12.5394 18.4814 12.9774 18.919 12.9774 19.4588V21.0221C12.9774 21.5624 12.5399 22 12 22C11.4601 22 11.0226 21.5624 11.0226 21.0221V19.4588Z"
                fill={strokeColor}
            />
            <path
                d="M16.5828 7.41674C16.2015 7.03499 16.2015 6.4163 16.5828 6.03454L17.6887 4.9287C18.07 4.54739 18.6891 4.54739 19.0709 4.9287C19.4526 5.31045 19.4526 5.92958 19.0709 6.31089L17.965 7.41674C17.5837 7.79849 16.965 7.79849 16.5828 7.41674Z"
                fill={strokeColor}
            />
            <path
                d="M6.03454 16.5837C6.4163 16.2015 7.03499 16.2015 7.41674 16.5837C7.79849 16.9646 7.79849 17.5837 7.41674 17.965L6.31089 19.0713C5.92958 19.4526 5.31045 19.4526 4.9287 19.0713C4.54694 18.69 4.54739 18.0704 4.9287 17.6891L6.03454 16.5837Z"
                fill={strokeColor}
            />
            <path
                d="M18.4814 12C18.4814 11.4601 18.919 11.0226 19.4588 11.0226H21.0226C21.5624 11.0226 22 11.4601 22 12C22 12.5399 21.5624 12.977 21.0226 12.977H19.4588C18.919 12.977 18.4814 12.5399 18.4814 12Z"
                fill={strokeColor}
            />
            <path
                d="M4.54074 11.0226C5.0806 11.0226 5.51816 11.4601 5.51816 12C5.51816 12.5399 5.0806 12.977 4.54119 12.977H2.97741C2.43756 12.977 2 12.5399 2 12C2 11.4601 2.43756 11.0226 2.97741 11.0226H4.54074Z"
                fill={strokeColor}
            />
            <path
                d="M16.5828 16.5837C16.9646 16.2024 17.5837 16.2024 17.965 16.5837L19.0709 17.6895C19.4526 18.0704 19.4526 18.69 19.0709 19.0713C18.6891 19.4526 18.0704 19.4526 17.6887 19.0713L16.5828 17.9655C16.2011 17.5837 16.2011 16.965 16.5828 16.5837Z"
                fill={strokeColor}
            />
            <path
                d="M7.41674 6.03454C7.79849 6.4163 7.79849 7.03499 7.41674 7.41674C7.03499 7.79894 6.4163 7.79894 6.03454 7.41674L4.9287 6.31089C4.54694 5.92958 4.54694 5.31045 4.9287 4.92914C5.31045 4.54739 5.92914 4.54739 6.31089 4.92914L7.41674 6.03454Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const DarkThemeIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12.999 21.9995C16.8252 22.0397 20.3202 19.835 21.9319 16.3647C20.9176 16.8073 19.8191 17.024 18.7127 17C14.3758 16.9951 10.8612 13.4805 10.8564 9.1436C10.8998 6.21001 12.5184 3.52665 15.093 2.11967C14.3987 2.03127 13.6989 1.99169 12.999 2.00145C7.47657 2.00145 3 6.47819 3 12.0005C3 17.5229 7.47657 21.9995 12.999 21.9995Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const WidgetsIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V7H2V6Z"
                fill={strokeColor}
            />
            <path
                d="M10 8H22V18C22 19.1046 21.1046 20 20 20H10L10 8Z"
                fill={strokeColor}
            />
            <path
                d="M9 8H2V18C2 19.1046 2.89543 20 4 20H9L9 8Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const SettingsLinesIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.1667 4.08332H18.9475C18.5858 2.8825 17.4833 2 16.1667 2C14.85 2 13.7475 2.8825 13.3858 4.08332H2.83332C2.37332 4.08332 2 4.45664 2 4.91664C2 5.37664 2.37332 5.74996 2.83332 5.74996H13.3858C13.7475 6.95082 14.85 7.83332 16.1667 7.83332C17.4834 7.83332 18.5859 6.95082 18.9475 5.75H21.1667C21.6275 5.75 22 5.37668 22 4.91668C22 4.45668 21.6275 4.08332 21.1667 4.08332ZM16.1667 6.16664C15.4775 6.16664 14.9167 5.60582 14.9167 4.91664C14.9167 4.22746 15.4775 3.66664 16.1667 3.66664C16.8559 3.66664 17.4167 4.22746 17.4167 4.91664C17.4167 5.60582 16.8558 6.16664 16.1667 6.16664Z"
                fill={strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.1667 17.4167H18.9475C18.5867 16.2158 17.4833 15.3333 16.1667 15.3333C14.85 15.3333 13.7475 16.2158 13.3859 17.4167H2.83332C2.37332 17.4167 2 17.79 2 18.25C2 18.71 2.37332 19.0833 2.83332 19.0833H13.3858C13.7466 20.2842 14.85 21.1667 16.1666 21.1667C17.4833 21.1667 18.5858 20.2842 18.9475 19.0833H21.1666C21.6275 19.0833 22 18.71 22 18.25C22 17.79 21.6275 17.4167 21.1667 17.4167ZM16.1667 19.5C15.4775 19.5 14.9167 18.9392 14.9167 18.25C14.9167 17.5608 15.4775 17 16.1667 17C16.8559 17 17.4167 17.5608 17.4167 18.25C17.4167 18.9392 16.8558 19.5 16.1667 19.5Z"
                fill={strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6142 10.75H21.1667C21.6275 10.75 22 11.1233 22 11.5833C22 12.0433 21.6275 12.4166 21.1666 12.4166H10.6141C10.2525 13.6174 9.14996 14.4999 7.83332 14.4999C6.51668 14.4999 5.41418 13.6174 5.0525 12.4166H2.83332C2.37332 12.4166 2 12.0433 2 11.5833C2 11.1233 2.37332 10.75 2.83332 10.75H5.05254C5.41418 9.54917 6.51672 8.66667 7.83336 8.66667C9.15 8.66667 10.2525 9.54917 10.6142 10.75ZM6.58332 11.5833C6.58332 12.2725 7.14414 12.8333 7.83332 12.8333C8.5225 12.8333 9.08332 12.2725 9.08332 11.5833C9.08332 10.8941 8.5225 10.3333 7.83332 10.3333C7.14414 10.3333 6.58332 10.8941 6.58332 11.5833Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const SubMenuIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <circle cx="12" cy="4" r="2" fill={strokeColor} />
            <circle cx="12" cy="12" r="2" fill={strokeColor} />
            <circle cx="12" cy="20" r="2" fill={strokeColor} />
        </svg>
    );
};

export const LockIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M15.4863 7.91699H14.4446V6.52809C14.4446 3.84766 12.264 1.66699 9.5835 1.66699C6.90303 1.66699 4.7224 3.84766 4.7224 6.52809V7.91699H3.68073C3.4888 7.91699 3.3335 8.0723 3.3335 8.26423V16.9448C3.3335 17.7108 3.95638 18.3337 4.7224 18.3337H14.4446C15.2106 18.3337 15.8335 17.7108 15.8335 16.9448V8.26423C15.8335 8.0723 15.6782 7.91699 15.4863 7.91699ZM10.6231 15.1703C10.634 15.2683 10.6025 15.3667 10.5367 15.4403C10.4709 15.5138 10.3766 15.5559 10.278 15.5559H8.88906C8.7904 15.5559 8.69613 15.5138 8.63034 15.4403C8.56455 15.3667 8.53301 15.2684 8.54388 15.1703L8.76292 13.2006C8.40723 12.9419 8.19463 12.5326 8.19463 12.0837C8.19463 11.3177 8.81751 10.6948 9.58353 10.6948C10.3495 10.6948 10.9724 11.3176 10.9724 12.0837C10.9724 12.5326 10.7598 12.9419 10.4041 13.2006L10.6231 15.1703ZM12.3613 7.91699H6.80573V6.52809C6.80573 4.99645 8.05186 3.75033 9.5835 3.75033C11.1151 3.75033 12.3613 4.99645 12.3613 6.52809V7.91699Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const AddUserIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1667 5.50001C14.1667 7.80119 12.3012 9.66668 10 9.66668C7.69882 9.66668 5.83333 7.80119 5.83333 5.50001C5.83333 3.19883 7.69882 1.33334 10 1.33334C12.3012 1.33334 14.1667 3.19883 14.1667 5.50001ZM8.33333 11.3333C5.11168 11.3333 2.5 13.945 2.5 17.1667C2.5 18.5474 3.61929 19.6667 5 19.6667H11.1744C11.5346 19.6667 11.7392 19.2268 11.5527 18.9186C11.0961 18.1643 10.8333 17.2795 10.8333 16.3333C10.8333 14.6383 11.6768 13.1402 12.967 12.2359C13.2698 12.0238 13.244 11.5368 12.8822 11.4602C12.4902 11.3771 12.0835 11.3333 11.6667 11.3333H8.33333ZM15.8333 13C16.2936 13 16.6667 13.3731 16.6667 13.8333V15.5H18.3333C18.7936 15.5 19.1667 15.8731 19.1667 16.3333C19.1667 16.7936 18.7936 17.1667 18.3333 17.1667H16.6667V18.8333C16.6667 19.2935 16.2936 19.6667 15.8333 19.6667C15.3731 19.6667 15 19.2935 15 18.8333V17.1667H13.3333C12.8731 17.1667 12.5 16.7936 12.5 16.3333C12.5 15.8731 12.8731 15.5 13.3333 15.5H15V13.8333C15 13.3731 15.3731 13 15.8333 13Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const EditIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M14.8615 10.4999C14.4774 10.4999 14.167 10.8111 14.167 11.1944V16.7501C14.167 17.1328 13.8559 17.4446 13.4726 17.4446H3.75003C3.36664 17.4446 3.0556 17.1328 3.0556 16.7501V7.02755C3.0556 6.64493 3.36664 6.33313 3.75003 6.33313H9.3058C9.68983 6.33313 10.0002 6.02197 10.0002 5.6387C10.0002 5.25532 9.68983 4.94415 9.3058 4.94415H3.75003C2.60138 4.94415 1.66663 5.87891 1.66663 7.02755V16.7501C1.66663 17.8988 2.60138 18.8335 3.75003 18.8335H13.4726C14.6212 18.8335 15.556 17.8988 15.556 16.7501V11.1944C15.556 10.8103 15.2455 10.4999 14.8615 10.4999Z"
                fill={strokeColor}
            />
            <path
                d="M8.1778 9.86748C8.12923 9.91605 8.09655 9.97785 8.08269 10.0445L7.59172 12.5002C7.56883 12.614 7.60494 12.7314 7.68684 12.814C7.75283 12.88 7.84172 12.9154 7.93277 12.9154C7.95489 12.9154 7.97791 12.9134 8.0008 12.9085L10.4558 12.4176C10.5238 12.4036 10.5856 12.371 10.6335 12.3223L16.1281 6.8277L13.6732 4.37286L8.1778 9.86748Z"
                fill={strokeColor}
            />
            <path
                d="M17.8255 2.6745C17.1485 1.99737 16.047 1.99737 15.3705 2.6745L14.4094 3.63559L16.8644 6.09055L17.8255 5.12934C18.1533 4.80228 18.3339 4.36612 18.3339 3.90224C18.3339 3.43836 18.1533 3.0022 17.8255 2.6745Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const DeleteIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.42596 2.16666C7.81232 2.16666 7.31486 2.66411 7.31486 3.27776C7.31486 3.58459 7.06612 3.83332 6.7593 3.83332H6.66671H4.16671C3.70647 3.83332 3.33337 4.20642 3.33337 4.66666C3.33337 5.12689 3.70647 5.49999 4.16671 5.49999H6.66671H6.7593H13.2395H13.2408H13.3334H15.8334C16.2936 5.49999 16.6667 5.12689 16.6667 4.66666C16.6667 4.20642 16.2936 3.83332 15.8334 3.83332H13.2401C12.9336 3.83296 12.6852 3.58437 12.6852 3.27776C12.6852 2.66411 12.1878 2.16666 11.5741 2.16666H8.42596Z"
                fill={strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.00008 7.16666C4.76704 7.16666 4.54465 7.26424 4.38685 7.43573C4.22906 7.60722 4.15027 7.83696 4.16963 8.0692L4.81193 15.7768C4.9559 17.5045 6.40012 18.8333 8.13375 18.8333H11.8664C13.6001 18.8333 15.0442 17.5045 15.1882 15.7768L15.8305 8.0692C15.8499 7.83696 15.7711 7.60722 15.6133 7.43573C15.4555 7.26424 15.2332 7.16666 15.0001 7.16666H5.00008Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CopyIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M8.57643 15.2086C6.94934 15.2086 5.625 13.8842 5.625 12.2571V5.13916H4.40976C3.35627 5.13916 2.5 5.99531 2.5 7.0488V16.4238C2.5 17.4773 3.35627 18.3336 4.40976 18.3336H13.0902C14.1437 18.3336 15 17.4773 15 16.4238V15.2086H8.57643Z"
                fill={strokeColor}
            />
            <path
                d="M17.7777 3.57642C17.7777 2.52153 16.9228 1.66666 15.8681 1.66666H8.57639C7.5215 1.66666 6.66663 2.52153 6.66663 3.57642V12.2569C6.66663 13.3118 7.5215 14.1667 8.57639 14.1667H15.8681C16.9228 14.1667 17.7777 13.3118 17.7777 12.2569V3.57642Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ApplyIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 17;
    const iconHeight = height ?? 12;
    const strokeColor = stroke ?? '#54C142';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 18 12"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9167 0.351472C17.3611 0.820101 17.3611 1.5799 16.9167 2.04853L7.81326 11.6485C7.36887 12.1172 6.64837 12.1172 6.20398 11.6485L1.08329 6.24853C0.638903 5.7799 0.638903 5.0201 1.08329 4.55147C1.52768 4.08284 2.24818 4.08284 2.69257 4.55147L7.00862 9.10294L15.3074 0.351472C15.7518 -0.117157 16.4723 -0.117157 16.9167 0.351472Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const PlusIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10.8333 3.33333C10.8333 2.8731 10.4602 2.5 10 2.5C9.53976 2.5 9.16667 2.8731 9.16667 3.33333V9.16667L3.33333 9.16667C2.87309 9.16667 2.5 9.53976 2.5 10C2.5 10.4602 2.87309 10.8333 3.33333 10.8333H9.16667V16.6667C9.16667 17.1269 9.53976 17.5 10 17.5C10.4602 17.5 10.8333 17.1269 10.8333 16.6667V10.8333H16.6667C17.1269 10.8333 17.5 10.4602 17.5 10C17.5 9.53976 17.1269 9.16667 16.6667 9.16667L10.8333 9.16667V3.33333Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const MinusIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#777777';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M20 12L4 12"
                stroke={strokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export const WarningIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 32;
    const iconHeight = height ?? 32;
    const strokeColor = stroke ?? '#d73737';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 32 32"
            fill="none"
        >
            <rect x="12" y="9.33398" width="8" height="17.3333" fill="white" />
            <path
                d="M28.7796 23.2287L19.3595 5.91225C17.8461 3.36428 14.1566 3.36089 12.6411 5.91225L3.22152 23.2287C1.67433 25.8323 3.54751 29.1293 6.57996 29.1293H25.4204C28.4503 29.1293 30.3268 25.835 28.7796 23.2287ZM16.0003 26.0043C15.139 26.0043 14.4378 25.3031 14.4378 24.4418C14.4378 23.5804 15.139 22.8793 16.0003 22.8793C16.8617 22.8793 17.5628 23.5804 17.5628 24.4418C17.5628 25.3031 16.8617 26.0043 16.0003 26.0043ZM17.5628 19.7543C17.5628 20.6156 16.8617 21.3168 16.0003 21.3168C15.139 21.3168 14.4378 20.6156 14.4378 19.7543V11.9418C14.4378 11.0804 15.139 10.3793 16.0003 10.3793C16.8617 10.3793 17.5628 11.0804 17.5628 11.9418V19.7543Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const InfoIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 32;
    const iconHeight = height ?? 32;
    const strokeColor = stroke ?? '#437EC3';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                d="M16 2.66602C8.64766 2.66602 2.66602 8.64741 2.66602 15.9993C2.66602 23.3514 8.64766 29.3327 16 29.3327C23.3524 29.3327 29.3341 23.3514 29.3341 15.9993C29.3341 8.64741 23.3524 2.66602 16 2.66602ZM16 26.9084C9.98445 26.9084 5.09038 22.0146 5.09038 15.9994C5.09038 9.98413 9.98445 5.09038 16 5.09038C22.0156 5.09038 26.9097 9.98413 26.9097 15.9993C26.9097 22.0147 22.0156 26.9084 16 26.9084Z"
                fill={strokeColor}
            />
            <path
                d="M16.0012 13.1719C15.3318 13.1719 14.7891 13.7146 14.7891 14.3841V22.4639C14.7891 23.1334 15.3318 23.6761 16.0012 23.6761C16.6707 23.6761 17.2134 23.1334 17.2134 22.4639V14.3841C17.2134 13.7147 16.6707 13.1719 16.0012 13.1719Z"
                fill={strokeColor}
            />
            <path
                d="M16.0012 8.32227C15.682 8.32227 15.37 8.45157 15.1438 8.67703C14.9184 8.9025 14.7891 9.21524 14.7891 9.53445C14.7891 9.85366 14.9184 10.1656 15.1438 10.3919C15.3693 10.6173 15.682 10.7466 16.0012 10.7466C16.3205 10.7466 16.6324 10.6173 16.8586 10.3919C17.084 10.1656 17.2134 9.85366 17.2134 9.53445C17.2134 9.21524 17.084 8.9025 16.8586 8.67703C16.6324 8.45148 16.3205 8.32227 16.0012 8.32227Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const TextWidgetIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M3.07368 4H16.2229C16.5397 4 16.7965 4.25684 16.7965 4.57368V8.01588C16.7965 8.33272 16.5397 8.58956 16.2228 8.58956H15.0754C14.7586 8.58956 14.5017 8.33272 14.5017 8.01588V6.86848H11.0825V17.7687H12.5167C12.8336 17.7687 13.0904 18.0256 13.0904 18.3424V19.4898C13.0904 19.8067 12.8336 20.0635 12.5167 20.0635H6.77976C6.46292 20.0635 6.20608 19.8067 6.20608 19.4898V18.3424C6.20608 18.0256 6.46292 17.7687 6.77976 17.7687H8.214V6.86848H4.79476V8.01588C4.79476 8.33272 4.53792 8.58956 4.22108 8.58956H3.07368C2.75684 8.58956 2.5 8.33272 2.5 8.01588V4.57368C2.5 4.25684 2.75684 4 3.07368 4Z"
                fill={strokeColor}
            />
            <path
                d="M13.617 9.665H22.1287C22.3338 9.665 22.5 9.83129 22.5 10.0364V12.2646C22.5 12.4696 22.3337 12.6359 22.1286 12.6359H21.3859C21.1808 12.6359 21.0146 12.4696 21.0146 12.2646V11.5218H18.8012V18.5778H19.7296C19.9347 18.5778 20.101 18.7441 20.101 18.9491V19.6919C20.101 19.8969 19.9348 20.0632 19.7296 20.0632H16.016C15.8109 20.0632 15.6446 19.8969 15.6446 19.6919V18.9491C15.6446 18.7441 15.8109 18.5778 16.016 18.5778H16.9444V11.5218H14.7311V12.2646C14.7311 12.4696 14.5648 12.6359 14.3597 12.6359H13.617C13.4119 12.6359 13.2456 12.4696 13.2456 12.2646V10.0364C13.2456 9.83129 13.4119 9.665 13.617 9.665Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const PieChartIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M13.6378 2.20921C13.7717 2.07525 13.9534 2 14.1429 2C16.226 2.00246 18.223 2.83105 19.696 4.30402C21.169 5.77699 21.9976 7.77406 22 9.85715C22 10.0466 21.9248 10.2283 21.7908 10.3622C21.6568 10.4962 21.4752 10.5714 21.2857 10.5714H14.1429C13.9534 10.5714 13.7717 10.4962 13.6378 10.3622C13.5038 10.2283 13.4286 10.0466 13.4286 9.85715V2.71429C13.4286 2.52485 13.5038 2.34316 13.6378 2.20921Z"
                fill={strokeColor}
            />
            <path
                d="M12.7143 12.0001H19.8614C19.9562 12.0006 20.0499 12.02 20.1371 12.0572C20.2243 12.0943 20.3033 12.1484 20.3694 12.2163C20.4354 12.2843 20.4873 12.3647 20.522 12.4529C20.5567 12.5411 20.5735 12.6353 20.5714 12.7301C20.5683 14.5653 20.0215 16.3584 19 17.883C17.9784 19.4076 16.528 20.5954 14.8319 21.2962C13.1358 21.9971 11.2701 22.1797 9.47031 21.8209C7.67053 21.4621 6.01741 20.578 4.71973 19.2803C3.42204 17.9827 2.53799 16.3295 2.17919 14.5298C1.8204 12.73 2.00297 10.8642 2.70383 9.16812C3.4047 7.47202 4.59243 6.02164 6.11705 5.00011C7.64167 3.97859 9.4348 3.43175 11.27 3.42864C11.3649 3.42732 11.4591 3.44478 11.5473 3.48001C11.6354 3.51525 11.7157 3.56756 11.7836 3.63395C11.8514 3.70033 11.9055 3.77948 11.9426 3.86683C11.9797 3.95418 11.9993 4.04801 12 4.14293V11.2858C12 11.4752 12.0753 11.6569 12.2092 11.7909C12.3432 11.9248 12.5248 12.0001 12.7143 12.0001Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const TableIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M21.9353 4.56487C21.5585 4.18822 21.106 4 20.577 4H4.42312C3.89429 4 3.44152 4.18822 3.06487 4.56487C2.6883 4.94161 2.5 5.3942 2.5 5.92317V19.0002C2.5 19.5292 2.6883 19.9814 3.06487 20.3583C3.44152 20.735 3.89424 20.9231 4.42312 20.9231H20.577C21.106 20.9231 21.5585 20.735 21.9353 20.3583C22.3118 19.9814 22.5 19.5289 22.5 19.0002V5.92317C22.5 5.3942 22.3118 4.94148 21.9353 4.56487ZM8.65401 18.9998C8.65401 19.1123 8.61785 19.2042 8.54565 19.2764C8.47358 19.3484 8.38151 19.3842 8.26919 19.3842H4.42312C4.31106 19.3842 4.21882 19.3484 4.14666 19.2764C4.07455 19.2042 4.03856 19.1123 4.03856 18.9998V16.6919C4.03856 16.5796 4.07455 16.4876 4.14666 16.4158C4.21882 16.3434 4.31106 16.3074 4.42312 16.3074H8.26932C8.3816 16.3074 8.47383 16.3434 8.54578 16.4158C8.61781 16.4876 8.65397 16.5796 8.65397 16.6919L8.65401 18.9998ZM8.65401 14.3846C8.65401 14.4967 8.61785 14.5889 8.54565 14.6609C8.47358 14.7331 8.38151 14.7691 8.26919 14.7691H4.42312C4.31106 14.7691 4.21882 14.7331 4.14666 14.6609C4.07455 14.5889 4.03856 14.4967 4.03856 14.3846V12.0768C4.03856 11.9647 4.07455 11.8725 4.14666 11.8004C4.21882 11.7284 4.31106 11.6924 4.42312 11.6924H8.26932C8.3816 11.6924 8.47366 11.7284 8.54578 11.8004C8.61781 11.8725 8.65397 11.9647 8.65397 12.0768L8.65401 14.3846ZM8.65401 9.76921C8.65401 9.88144 8.61785 9.97351 8.54565 10.0457C8.47358 10.1176 8.38151 10.1538 8.26919 10.1538H4.42312C4.31106 10.1538 4.21882 10.1176 4.14666 10.0457C4.07455 9.97347 4.03856 9.88144 4.03856 9.76921V7.46151C4.03856 7.34928 4.07455 7.25709 4.14666 7.18506C4.21882 7.11294 4.31106 7.07695 4.42312 7.07695H8.26932C8.3816 7.07695 8.47366 7.11294 8.54578 7.18506C8.61781 7.25709 8.65397 7.34928 8.65397 7.46151L8.65401 9.76921ZM14.8079 18.9998C14.8079 19.1123 14.7719 19.2042 14.7 19.2764C14.6279 19.3484 14.5358 19.3842 14.4234 19.3842H10.5769C10.4648 19.3842 10.3726 19.3484 10.3005 19.2764C10.2284 19.2042 10.1924 19.1123 10.1924 18.9998V16.6919C10.1924 16.5796 10.2284 16.4876 10.3005 16.4158C10.3726 16.3434 10.4648 16.3074 10.5769 16.3074H14.4232C14.5356 16.3074 14.6278 16.3434 14.6998 16.4158C14.7715 16.4876 14.8076 16.5796 14.8076 16.6919V18.9997L14.8079 18.9998ZM14.8079 14.3846C14.8079 14.4967 14.7719 14.5889 14.7 14.6609C14.6279 14.7331 14.5358 14.7691 14.4234 14.7691H10.5769C10.4648 14.7691 10.3726 14.7331 10.3005 14.6609C10.2284 14.5889 10.1924 14.4967 10.1924 14.3846V12.0768C10.1924 11.9647 10.2284 11.8725 10.3005 11.8004C10.3726 11.7284 10.4648 11.6924 10.5769 11.6924H14.4232C14.5356 11.6924 14.6278 11.7284 14.6998 11.8004C14.7715 11.8725 14.8076 11.9647 14.8076 12.0768V14.3846H14.8079ZM14.8079 9.76921C14.8079 9.88144 14.7719 9.97351 14.7 10.0457C14.6279 10.1176 14.5358 10.1538 14.4234 10.1538H10.5769C10.4648 10.1538 10.3726 10.1176 10.3005 10.0457C10.2284 9.97347 10.1924 9.88144 10.1924 9.76921V7.46151C10.1924 7.34928 10.2284 7.25709 10.3005 7.18506C10.3726 7.11294 10.4648 7.07695 10.5769 7.07695H14.4232C14.5356 7.07695 14.6278 7.11294 14.6998 7.18506C14.7715 7.25709 14.8076 7.34928 14.8076 7.46151V9.76921H14.8079ZM20.9615 18.9998C20.9615 19.1123 20.9255 19.2042 20.8536 19.2764C20.7813 19.3484 20.6891 19.3842 20.577 19.3842H16.7312C16.6187 19.3842 16.5265 19.3484 16.4546 19.2764C16.3826 19.2042 16.3468 19.1123 16.3468 18.9998V16.6919C16.3468 16.5796 16.3826 16.4876 16.4546 16.4158C16.5265 16.3434 16.6187 16.3074 16.7312 16.3074H20.577C20.6891 16.3074 20.7813 16.3434 20.8536 16.4158C20.9255 16.4876 20.9615 16.5796 20.9615 16.6919V18.9998ZM20.9615 14.3846C20.9615 14.4967 20.9255 14.5889 20.8536 14.6609C20.7813 14.7331 20.6891 14.7691 20.577 14.7691H16.7312C16.6187 14.7691 16.5265 14.7331 16.4546 14.6609C16.3826 14.5889 16.3468 14.4967 16.3468 14.3846V12.0768C16.3468 11.9647 16.3826 11.8725 16.4546 11.8004C16.5265 11.7284 16.6187 11.6924 16.7312 11.6924H20.577C20.6891 11.6924 20.7813 11.7284 20.8536 11.8004C20.9255 11.8725 20.9615 11.9647 20.9615 12.0768V14.3846ZM20.9615 9.76921C20.9615 9.88144 20.9255 9.97351 20.8536 10.0457C20.7813 10.1176 20.6891 10.1538 20.577 10.1538H16.7312C16.6187 10.1538 16.5265 10.1176 16.4546 10.0457C16.3826 9.97347 16.3468 9.88144 16.3468 9.76921V7.46151C16.3468 7.34928 16.3826 7.25709 16.4546 7.18506C16.5265 7.11294 16.6187 7.07695 16.7312 7.07695H20.577C20.6891 7.07695 20.7813 7.11294 20.8536 7.18506C20.9255 7.25709 20.9615 7.34928 20.9615 7.46151V9.76921Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const CounterIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M16.2061 9.89093L16.0825 10.1025L14.1436 13.2124H16.2061V9.89093Z"
                fill={strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22ZM12.0811 16V14.9688H8.47168L10.1636 13.105C10.3999 12.8615 10.6165 12.6216 10.8135 12.3853C11.0104 12.1453 11.1805 11.9072 11.3237 11.6709C11.4705 11.431 11.5833 11.1911 11.6621 10.9512C11.7409 10.7113 11.7803 10.4696 11.7803 10.2261C11.7803 9.78564 11.6836 9.4043 11.4902 9.08203C11.3005 8.75977 11.0229 8.51091 10.6577 8.33545C10.2925 8.15999 9.84847 8.07227 9.32568 8.07227C8.77067 8.07227 8.29622 8.18506 7.90234 8.41064C7.50846 8.63265 7.20768 8.93343 7 9.31299C6.79232 9.68896 6.68848 10.1043 6.68848 10.5591H7.98291C7.98291 10.2762 8.03304 10.0256 8.1333 9.80713C8.23356 9.58512 8.38216 9.41146 8.5791 9.28613C8.77604 9.16081 9.01953 9.09814 9.30957 9.09814C9.56022 9.09814 9.77327 9.15365 9.94873 9.26465C10.1242 9.37207 10.2567 9.52067 10.3462 9.71045C10.4393 9.89665 10.4858 10.1133 10.4858 10.3604C10.4858 10.5358 10.4518 10.7166 10.3838 10.9028C10.3193 11.0854 10.2065 11.2913 10.0454 11.5205C9.88428 11.7497 9.66406 12.0218 9.38477 12.3369L6.83887 15.1138V16H12.0811ZM18.478 14.2437V13.2124H17.5005V8.17969H16.1685L12.7954 13.4648L12.8384 14.2437H16.2061V16H17.5005V14.2437H18.478Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const BarChartIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M3.5 2C4.05228 2 4.5 2.44772 4.5 3V20H21.5C22.0523 20 22.5 20.4477 22.5 21C22.5 21.5523 22.0523 22 21.5 22H3.5C2.94772 22 2.5 21.5523 2.5 21V3C2.5 2.44772 2.94772 2 3.5 2Z"
                fill={strokeColor}
            />
            <path
                d="M10.5909 11.1818V17.3182C10.5909 17.499 10.5191 17.6724 10.3912 17.8003C10.2633 17.9282 10.0899 18 9.90909 18H7.18182C7.00099 18 6.82757 17.9282 6.6997 17.8003C6.57183 17.6724 6.5 17.499 6.5 17.3182V11.1818C6.5 11.001 6.57183 10.8276 6.6997 10.6997C6.82757 10.5718 7.00099 10.5 7.18182 10.5H9.90909C10.0899 10.5 10.2633 10.5718 10.3912 10.6997C10.5191 10.8276 10.5909 11.001 10.5909 11.1818Z"
                fill={strokeColor}
            />
            <path
                d="M15.3636 3H12.6364C12.4555 3 12.2821 3.07183 12.1542 3.1997C12.0264 3.32757 11.9545 3.50099 11.9545 3.68182V17.3182C11.9545 17.499 12.0264 17.6724 12.1542 17.8003C12.2821 17.9282 12.4555 18 12.6364 18H15.3636C15.5445 18 15.7179 17.9282 15.8458 17.8003C15.9736 17.6724 16.0455 17.499 16.0455 17.3182V3.68182C16.0455 3.50099 15.9736 3.32757 15.8458 3.1997C15.7179 3.07183 15.5445 3 15.3636 3Z"
                fill={strokeColor}
            />
            <path
                d="M20.8182 6.40909H18.0909C17.9101 6.40909 17.7367 6.48093 17.6088 6.60879C17.4809 6.73666 17.4091 6.91008 17.4091 7.09091V17.3182C17.4091 17.499 17.4809 17.6724 17.6088 17.8003C17.7367 17.9282 17.9101 18 18.0909 18H20.8182C20.999 18 21.1724 17.9282 21.3003 17.8003C21.4282 17.6724 21.5 17.499 21.5 17.3182V7.09091C21.5 6.91008 21.4282 6.73666 21.3003 6.60879C21.1724 6.48093 20.999 6.40909 20.8182 6.40909Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const LineChartIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M3.5 2C4.05228 2 4.5 2.44772 4.5 3V20H21.5C22.0523 20 22.5 20.4477 22.5 21C22.5 21.5523 22.0523 22 21.5 22H3.5C2.94772 22 2.5 21.5523 2.5 21V3C2.5 2.44772 2.94772 2 3.5 2Z"
                fill={strokeColor}
            />
            <path
                d="M20.7894 8.61394C21.1284 8.17799 21.0499 7.54972 20.6139 7.21065C20.178 6.87158 19.5497 6.95011 19.2106 7.38606L16.2367 11.2097L12.4856 9.12584C12.0782 8.8995 11.5685 8.98461 11.2567 9.33104L6.75671 14.331C6.38725 14.7415 6.42053 15.3738 6.83104 15.7433C7.24155 16.1128 7.87384 16.0795 8.24329 15.669L12.2105 11.2609L16.0144 13.3742C16.4454 13.6136 16.9866 13.5032 17.2894 13.1139L20.7894 8.61394Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const BriefcaseIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M20.3333 6.50003H16.1667V5.66668C16.1667 4.7475 15.4192 4 14.5 4H9.49999C8.58081 4 7.83331 4.74746 7.83331 5.66668V6.5H3.66668C2.74746 6.50003 2 7.24749 2 8.16667V10.6667C2 11.5859 2.74746 12.3333 3.66668 12.3333H10.3333V11.9167C10.3333 11.6864 10.5197 11.5 10.75 11.5H13.25C13.4803 11.5 13.6667 11.6864 13.6667 11.9167V12.3333H20.3334C21.2525 12.3333 22 11.5859 22 10.6667V8.16667C22 7.24749 21.2525 6.50003 20.3333 6.50003ZM14.5 6.50003H9.49999V5.66668H14.5V6.50003Z"
                fill={strokeColor}
            />
            <path
                d="M21.7688 12.7823C21.6268 12.7119 21.4571 12.7282 21.3318 12.8234C21.0356 13.0476 20.6905 13.166 20.3332 13.166H13.6667V14.416C13.6667 14.6463 13.4803 14.8327 13.25 14.8327H10.75C10.5197 14.8327 10.3333 14.6463 10.3333 14.416V13.166H3.66668C3.30941 13.166 2.96437 13.0476 2.66812 12.8234C2.54238 12.7274 2.37312 12.7111 2.23109 12.7823C2.08953 12.8527 2 12.9971 2 13.1554V18.9993C2 19.9185 2.74746 20.666 3.66668 20.666H20.3333C21.2525 20.666 22 19.9186 22 18.9993V13.1554C22 12.9971 21.9104 12.8527 21.7688 12.7823Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ExcelIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18.875 8.00098H17.625C17.28 8.00098 17 8.28098 17 8.62598C17 8.97098 17.28 9.25098 17.625 9.25098H18.875C19.22 9.25098 19.5 8.97098 19.5 8.62598C19.5 8.28098 19.22 8.00098 18.875 8.00098Z"
                fill={strokeColor}
            />
            <path
                d="M17.625 10.501H18.875C19.22 10.501 19.5 10.781 19.5 11.126C19.5 11.471 19.22 11.751 18.875 11.751H17.625C17.28 11.751 17 11.471 17 11.126C17 10.781 17.28 10.501 17.625 10.501Z"
                fill={strokeColor}
            />
            <path
                d="M18.875 13.001H17.625C17.28 13.001 17 13.281 17 13.626C17 13.971 17.28 14.251 17.625 14.251H18.875C19.22 14.251 19.5 13.971 19.5 13.626C19.5 13.281 19.22 13.001 18.875 13.001Z"
                fill={strokeColor}
            />
            <path
                d="M17.625 15.501H18.875C19.22 15.501 19.5 15.781 19.5 16.126C19.5 16.471 19.22 16.751 18.875 16.751H17.625C17.28 16.751 17 16.471 17 16.126C17 15.781 17.28 15.501 17.625 15.501Z"
                fill={strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.375 5.50084H13.25V3.62584C13.25 3.43959 13.1675 3.26334 13.0238 3.14459C12.8813 3.02584 12.69 2.97459 12.51 3.01209L2.51 4.88709C2.21375 4.94209 2 5.19959 2 5.50084V19.2508C2 19.5508 2.21375 19.8096 2.51 19.8646L12.51 21.7396C12.5475 21.7471 12.5863 21.7508 12.625 21.7508C12.77 21.7508 12.9113 21.7008 13.0238 21.6071C13.1675 21.4883 13.25 21.3108 13.25 21.1258V19.2508H21.375C21.72 19.2508 22 18.9708 22 18.6258V6.12584C22 5.78084 21.72 5.50084 21.375 5.50084ZM10.595 14.4646C10.8225 14.7233 10.7963 15.1183 10.5363 15.3458C10.4175 15.4496 10.2712 15.5008 10.125 15.5008C9.95125 15.5008 9.77875 15.4283 9.655 15.2871L7.8375 13.2108L6.24375 15.2608C6.12 15.4183 5.935 15.5008 5.75 15.5008C5.61625 15.5008 5.48125 15.4583 5.36625 15.3696C5.09375 15.1571 5.045 14.7646 5.25625 14.4921L6.99875 12.2521L5.28 10.2871C5.0525 10.0283 5.07875 9.63334 5.33875 9.40584C5.5975 9.17834 5.99125 9.20334 6.22125 9.46459L7.78125 11.2471L9.6325 8.86709C9.845 8.59584 10.2375 8.54584 10.51 8.75834C10.7825 8.96959 10.8313 9.36209 10.6187 9.63584L8.61875 12.2058L10.595 14.4646ZM13.25 18.0008V16.7508H15.125C15.47 16.7508 15.75 16.4708 15.75 16.1258C15.75 15.7808 15.47 15.5008 15.125 15.5008H13.25V14.2508H15.125C15.47 14.2508 15.75 13.9708 15.75 13.6258C15.75 13.2808 15.47 13.0008 15.125 13.0008H13.25V11.7508H15.125C15.47 11.7508 15.75 11.4708 15.75 11.1258C15.75 10.7808 15.47 10.5008 15.125 10.5008H13.25V9.25084H15.125C15.47 9.25084 15.75 8.97084 15.75 8.62584C15.75 8.28084 15.47 8.00084 15.125 8.00084H13.25V6.75084H20.75V18.0008H13.25Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ShareIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 2H6C3.791 2 2 3.791 2 6V18C2 20.209 3.791 22 6 22H18C20.209 22 22 20.209 22 18C22 15.729 22 13 22 13C22 12.448 21.552 12 21 12C20.448 12 20 12.448 20 13V18C20 19.104 19.104 20 18 20C14.67 20 9.329 20 6 20C4.895 20 4 19.104 4 18C4 14.67 4 9.329 4 6C4 4.895 4.895 4 6 4H11C11.552 4 12 3.552 12 3C12 2.448 11.552 2 11 2ZM18.586 4H15C14.448 4 14 3.552 14 3C14 2.448 14.448 2 15 2H21C21.552 2 22 2.448 22 3V9C22 9.552 21.552 10 21 10C20.448 10 20 9.552 20 9V5.414L12.707 12.707C12.317 13.097 11.683 13.097 11.293 12.707C10.902 12.317 10.902 11.683 11.293 11.293L18.586 4Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const MoveIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg width={iconWidth} height={iconHeight} viewBox="0 0 52 52">
            <path
                d="M49.7,25.3l-8.3-9c-0.6-0.6-1.4-0.1-1.4,0.9V23H30c-0.6,0-1-0.4-1-1V12h5.9c1,0,1.5-0.9,0.9-1.4l-9-8.3 c-0.4-0.3-1-0.3-1.4,0l-9,8.3c-0.6,0.6-0.1,1.4,0.9,1.4H23v10c0,0.6-0.4,1-1,1H12v-5.9c0-1-0.9-1.5-1.4-0.9l-8.3,9 c-0.3,0.4-0.3,1,0,1.4l8.3,9c0.6,0.6,1.4,0.1,1.4-0.9V29h10c0.6,0,1,0.4,1,1v10h-5.9c-1,0-1.5,0.9-0.9,1.4l9,8.3 c0.4,0.3,1,0.3,1.4,0l9-8.3c0.6-0.6,0.1-1.4-0.9-1.4H29V30c0-0.6,0.4-1,1-1h10v5.9c0,1,0.9,1.5,1.4,0.9l8.3-9 C50.1,26.3,50.1,25.7,49.7,25.3z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ReturnIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M18.0554 10.2294C17.1602 7.34912 14.3189 5.38356 10.9132 5.32518V1.95842C10.9132 1.80273 10.7769 1.6665 10.6213 1.6665C10.5629 1.6665 10.5045 1.68596 10.4461 1.72489L1.78595 7.99134C1.64972 8.08864 1.63026 8.26379 1.72756 8.40002C1.74702 8.41948 1.76649 8.43894 1.78595 8.4584L10.4461 14.6859C10.5823 14.7832 10.7575 14.7443 10.8548 14.6275C10.8937 14.5692 10.9132 14.5108 10.9132 14.4524V11.1051C13.015 11.1051 14.7859 12.0976 15.4087 13.5961C15.9341 14.8805 15.506 16.2623 14.2605 17.4105C14.1437 17.5272 14.1242 17.7024 14.241 17.8192C14.2994 17.8775 14.3772 17.9165 14.4551 17.9165H14.6886C14.747 17.9165 14.8054 17.897 14.8443 17.8581C17.7051 15.9704 18.9311 13.0317 18.0554 10.2294Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const DirectionIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M21 4.5C21 3.67157 20.3284 3 19.5 3L14.25 3C13.4216 3 12.75 3.67157 12.75 4.5L12.75 19.5C12.75 20.3284 13.4216 21 14.25 21L19.5 21C20.3284 21 21 20.3284 21 19.5L21 4.5Z"
                fill={strokeColor}
            />
            <path
                d="M11.25 4.5C11.25 3.67157 10.5784 3 9.75 3L4.5 3C3.67157 3 3 3.67157 3 4.5L3 19.5C3 20.3284 3.67157 21 4.5 21L9.75 21C10.5784 21 11.25 20.3284 11.25 19.5L11.25 4.5Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const SaveIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M5 3.57143V0H12.1429V3.57143C12.1429 3.76087 12.0676 3.94255 11.9336 4.0765C11.7997 4.21046 11.618 4.28571 11.4286 4.28571H5.71429C5.52485 4.28571 5.34316 4.21046 5.20921 4.0765C5.07525 3.94255 5 3.76087 5 3.57143ZM4.28571 20H15.7143V17.5429H4.28571V20ZM4.28571 16.1143H15.7143V14.6857H4.28571V16.1143ZM19.2857 4.78571L15.9786 0.778571C15.7778 0.535373 15.5258 0.339493 15.2406 0.20491C14.9554 0.0703272 14.6439 0.000359422 14.3286 0H13.5714V3.57143C13.5714 4.13975 13.3457 4.68479 12.9438 5.08666C12.5419 5.48852 11.9969 5.71429 11.4286 5.71429H5.71429C5.14596 5.71429 4.60092 5.48852 4.19906 5.08666C3.79719 4.68479 3.57143 4.13975 3.57143 3.57143V0H2.14286C1.57454 0 1.02949 0.225765 0.627628 0.627628C0.225765 1.02949 0 1.57454 0 2.14286V17.8571C0 18.4255 0.225765 18.9705 0.627628 19.3724C1.02949 19.7742 1.57454 20 2.14286 20H2.85714V12.8571C2.85714 12.2888 3.08291 11.7438 3.48477 11.3419C3.88664 10.9401 4.43168 10.7143 5 10.7143H15C15.5683 10.7143 16.1134 10.9401 16.5152 11.3419C16.9171 11.7438 17.1429 12.2888 17.1429 12.8571V20H17.8571C18.4255 20 18.9705 19.7742 19.3724 19.3724C19.7742 18.9705 20 18.4255 20 17.8571V6.37143C19.9984 6.07187 19.934 5.77598 19.811 5.50285C19.6879 5.22972 19.509 4.98542 19.2857 4.78571ZM15 12.1429H5C4.81056 12.1429 4.62888 12.2181 4.49492 12.3521C4.36097 12.486 4.28571 12.6677 4.28571 12.8571V13.2571H15.7143V12.8571C15.7143 12.6677 15.639 12.486 15.5051 12.3521C15.3711 12.2181 15.1894 12.1429 15 12.1429Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const TargetIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10.0002 0C8.50092 0 7.08337 0.381448 5.80688 0.977271L7.60431 2.7747C8.35869 2.52384 9.16272 2.38283 10.0002 2.38283C14.2002 2.38279 17.6174 5.8 17.6174 9.99998C17.6174 14.2 14.2002 17.6172 10.0002 17.6172C5.80016 17.6172 2.38299 14.2 2.38299 9.99998C2.38299 9.16248 2.52405 8.35845 2.77487 7.60407L0.977436 5.80664C0.38169 7.08317 0.000203454 8.50071 0.000203454 9.99998C0.000203454 15.4926 4.50761 20 10.0002 20C15.4928 20 20.0002 15.4926 20.0002 9.99998C20.0002 4.50741 15.4928 0 10.0002 0Z"
                fill={strokeColor}
            />
            <path
                d="M10.4219 9.59707C10.4203 9.59539 10.4193 9.59343 10.4182 9.59148L10.4165 9.58848L10.4144 9.5857L7.07043 6.24174V4.14059C7.07043 3.98493 7.00863 3.83618 6.89878 3.72629L3.38314 0.171625C3.21607 0.00459244 2.96372 -0.0463454 2.74454 0.0446317C2.5254 0.135023 2.3829 0.349048 2.3829 0.585924V2.34375H0.586012C0.349175 2.34371 0.13515 2.48617 0.0447591 2.70535C-0.046218 2.92449 0.00413381 3.17629 0.171791 3.34395L3.7265 6.89862C3.83638 7.0085 3.98513 7.0703 4.14076 7.0703H6.24191L9.58583 10.4142C9.58754 10.4159 9.58957 10.417 9.5916 10.4181C9.59356 10.4191 9.59551 10.4202 9.5972 10.4218C9.82533 10.6395 10.1719 10.6424 10.403 10.4218C10.6465 10.1895 10.641 9.82656 10.4219 9.59707Z"
                fill={strokeColor}
            />
            <path
                d="M8.2423 5.05054C8.79484 4.85355 9.38078 4.72659 10.0001 4.72659C12.9081 4.72659 15.2736 7.09207 15.2736 10C15.2736 12.908 12.908 15.2734 10.0001 15.2734C7.09221 15.2734 4.72669 12.908 4.72669 10C4.72669 9.38068 4.85365 8.79474 5.05064 8.2422H5.75666L7.1112 9.59682C7.10861 9.61531 7.10596 9.63378 7.1033 9.65225C7.08686 9.76667 7.07042 9.88114 7.07042 10.0001C7.07042 11.6154 8.38476 12.9298 10.0001 12.9298C11.6155 12.9298 12.9298 11.6154 12.9298 10.0001C12.9298 8.3847 11.6155 7.07035 10.0001 7.07035C9.88126 7.07035 9.76683 7.08679 9.65241 7.10323C9.63391 7.10589 9.6154 7.10855 9.59688 7.11114L8.2423 5.75656V5.05054Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const FilterIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M17.2259 1.66699H2.3671C2.10487 1.6665 1.86461 1.8129 1.74481 2.04605C1.62336 2.28234 1.64468 2.56689 1.79984 2.78269L7.24347 10.4513C7.24529 10.4539 7.24727 10.4564 7.24909 10.459C7.44688 10.7261 7.55396 11.0496 7.55445 11.3819V17.634C7.5533 17.8191 7.626 17.9971 7.75637 18.1284C7.88691 18.2596 8.06438 18.3337 8.24945 18.3337C8.34347 18.3335 8.43666 18.3148 8.52358 18.2786L11.5825 17.1124C11.8565 17.0286 12.0384 16.77 12.0384 16.4587V11.3819C12.0389 11.0496 12.1459 10.7261 12.3436 10.459C12.3454 10.4564 12.3474 10.4539 12.3492 10.4513L17.793 2.78252C17.9482 2.56689 17.9695 2.28251 17.848 2.04622C17.7284 1.8129 17.488 1.6665 17.2259 1.66699Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const GroupPlusIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#313131';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M2 6.55621C2 10.3083 2.80416 11.1125 6.55621 11.1125C10.3083 11.1125 11.1125 10.3083 11.1124 6.55621C11.1124 2.80416 10.3083 2 6.55621 2C2.80416 2 2 2.80416 2 6.55621Z"
                fill={strokeColor}
            />
            <path
                d="M2 17.4438C2 21.1958 2.80416 22 6.55621 22C10.3083 22 11.1125 21.1958 11.1124 17.4438C11.1124 13.6917 10.3083 12.8876 6.55621 12.8876C2.80416 12.8876 2 13.6917 2 17.4438Z"
                fill={strokeColor}
            />
            <path
                d="M12.7692 6.55621C12.7692 10.3082 13.5734 11.1124 17.3255 11.1124C21.0776 11.1124 21.8817 10.3082 21.8817 6.55621C21.8817 2.80412 21.0776 2 17.3255 2C13.5734 2 12.7692 2.80412 12.7692 6.55621Z"
                fill={strokeColor}
            />
            <path
                d="M17.3255 13.8343C17.783 13.8343 18.1539 14.2052 18.1539 14.6627V16.7337H20.2249C20.6824 16.7337 21.0532 17.1046 21.0532 17.5622C21.0532 18.0197 20.6823 18.3905 20.2248 18.3905H18.1538V20.4615C18.1538 20.9191 17.7829 21.2899 17.3254 21.2899C16.8679 21.2899 16.497 20.9191 16.497 20.4615V18.3905H14.426C13.9685 18.3905 13.5976 18.0196 13.5976 17.5621C13.5976 17.1046 13.9685 16.7337 14.426 16.7337H16.4971V14.6627C16.4971 14.2052 16.868 13.8343 17.3255 13.8343Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ShowMoreIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 20;
    const iconHeight = height ?? 20;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 1.25C20 0.559649 19.4404 0 18.75 0H1.25C0.559649 0 0 0.559649 0 1.25C0 1.94035 0.559649 2.5 1.25 2.5H18.75C19.4404 2.5 20 1.94039 20 1.25ZM5.57121 13.0712C5.8911 13.0712 6.21102 13.1932 6.45508 13.4373L8.75 15.7322V6.09371C8.75 5.40336 9.30965 4.84371 10 4.84371C10.6904 4.84371 11.25 5.40336 11.25 6.09371V15.7322L13.5449 13.4373C14.0331 12.9491 14.8245 12.9491 15.3127 13.4373C15.8009 13.9255 15.8009 14.7169 15.3127 15.2051L10.8839 19.6339C10.3957 20.122 9.60426 20.122 9.1161 19.6339L4.68731 15.2051C4.19914 14.7169 4.19914 13.9255 4.68731 13.4373C4.93141 13.1932 5.25129 13.0712 5.57121 13.0712Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const ConfirmIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 25;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? 'white';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.5 12L10 17.5L21.5 6"
                stroke={strokeColor}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DangerButton: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 32;
    const iconHeight = height ?? 32;
    const strokeColor = stroke ?? '#F94D4D';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 32 32"
            fill="none"
        >
            <rect x="12" y="9.33398" width="8" height="17.3333" fill="white" />
            <path
                d="M28.7786 23.2287L19.3586 5.91225C17.8451 3.36428 14.1556 3.36089 12.6401 5.91225L3.22054 23.2287C1.67335 25.8323 3.54653 29.1293 6.57898 29.1293H25.4194C28.4493 29.1293 30.3258 25.835 28.7786 23.2287ZM15.9993 26.0043C15.138 26.0043 14.4368 25.3031 14.4368 24.4418C14.4368 23.5804 15.138 22.8793 15.9993 22.8793C16.8607 22.8793 17.5618 23.5804 17.5618 24.4418C17.5618 25.3031 16.8607 26.0043 15.9993 26.0043ZM17.5618 19.7543C17.5618 20.6156 16.8607 21.3168 15.9993 21.3168C15.138 21.3168 14.4368 20.6156 14.4368 19.7543V11.9418C14.4368 11.0804 15.138 10.3793 15.9993 10.3793C16.8607 10.3793 17.5618 11.0804 17.5618 11.9418V19.7543Z"
                fill={strokeColor}
            />
        </svg>
    );
};

export const PrinterIcon: React.FC<IconProps> = props => {
    const { width, height, stroke } = props;

    const iconWidth = width ?? 24;
    const iconHeight = height ?? 24;
    const strokeColor = stroke ?? '#383838';

    return (
        <svg
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M19.8047 4.64062V3.51562C19.8047 1.57711 18.2276 0 16.2891 0H7.66406C5.72555 0 4.14844 1.57711 4.14844 3.51562V4.64062H19.8047Z"
                fill={strokeColor}
            />
            <path
                d="M5.55469 14.9531V20.6719V21.8906V22.5938C5.55469 23.3704 6.18427 24 6.96094 24H16.9922C17.7689 24 18.3984 23.3704 18.3984 22.5938V21.8906V20.6719V14.9531H5.55469ZM13.8516 20.9531H10.1016C9.71325 20.9531 9.39844 20.6383 9.39844 20.25C9.39844 19.8617 9.71325 19.5469 10.1016 19.5469H13.8516C14.2399 19.5469 14.5547 19.8617 14.5547 20.25C14.5547 20.6383 14.2399 20.9531 13.8516 20.9531ZM13.8516 17.9531H10.1016C9.71325 17.9531 9.39844 17.6383 9.39844 17.25C9.39844 16.8617 9.71325 16.5469 10.1016 16.5469H13.8516C14.2399 16.5469 14.5547 16.8617 14.5547 17.25C14.5547 17.6383 14.2399 17.9531 13.8516 17.9531Z"
                fill={strokeColor}
            />
            <path
                d="M20.4609 6.04688H3.53906C1.60055 6.04688 0.0234375 7.62398 0.0234375 9.5625V15.1875C0.0234375 17.126 1.60055 18.7031 3.53906 18.7031H4.14844V14.9531H3.72656C3.33825 14.9531 3.02344 14.6383 3.02344 14.25C3.02344 13.8617 3.33825 13.5469 3.72656 13.5469H4.85156H19.1016H20.2266C20.6149 13.5469 20.9297 13.8617 20.9297 14.25C20.9297 14.6383 20.6149 14.9531 20.2266 14.9531H19.8047V18.7031H20.4609C22.3995 18.7031 23.9766 17.126 23.9766 15.1875V9.5625C23.9766 7.62398 22.3995 6.04688 20.4609 6.04688ZM5.97656 10.4531H3.72656C3.33825 10.4531 3.02344 10.1383 3.02344 9.75C3.02344 9.36169 3.33825 9.04688 3.72656 9.04688H5.97656C6.36487 9.04688 6.67969 9.36169 6.67969 9.75C6.67969 10.1383 6.36487 10.4531 5.97656 10.4531Z"
                fill={strokeColor}
            />
        </svg>
    );
};
